import { NavigateFunction } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks.tsx';

export const inboxPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  { label: 'Inicio', onClick: () => navigate('/') },
];

export const childrenAttendTrackPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  ...inboxPageBreadcrumbs(navigate),
  { label : 'Monitoreo de agendas', onClick: () => navigate('/attend-track') },
];

export const childrenInboxPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  ...childrenAttendTrackPageBreadcrumbs(navigate),
  { label : 'Buzón de entrada', onClick: () => navigate('/attend-track') },
];